export class Social {
  religious: number[] = [];
  collgeSportsClassIds: any[] = [];
  collgeSportsConferenceClassIds: number[] = [];
  clubSportsClassIds: number[] = [];
  airROTC = null;
  armyROTC = null;
  navyROTC = null;
  generalROTC = null;
  housingWomen = null;
  housingCoed = null;
  housingDisabled = null;
  housingMen = null;
  genderClassId = null;
  greekLife = null;
}
